import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getAllTeams } from '../../api/documentAPI';

export default function TeamsMultiselect ({ selectedValues, onChange }) {
    
    const dropdownRef = useRef(null);
    const [t] = useTranslation('global');
    const [teams, setTeams] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(()=> {
        const fetchTeams = async () => {
            try {
              const response = await getAllTeams();
              const teams = response.map((team) => ({
                value : team.Id,
                label: team.Name 
              }));
              setTeams(teams);
            } catch (error) {
              console.error("Error fetching data: ", error);
            };
          }

        fetchTeams();
    },[]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false); // Close dropdown
            }
        };

        document.addEventListener('mousedown', handleClickOutside); // Listen for clicks
        return () => {
            document.removeEventListener('mousedown', handleClickOutside); // Cleanup on unmount
        };
    }, []);

    const handleSelect = (value) => {
        if (selectedValues.includes(value)) {
            // Remove value
            onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
        } else {
            // Add value
            onChange({ target: { value: [...selectedValues, value] } });
        }
    };

    const handleDelete = (value) => {
        onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const filteredTeams = teams.filter((team) =>
        team.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="mill-multiselect" ref={dropdownRef}>
            <label>{t('teams')}</label>
            <div className="multiselect-line" onClick={toggleDropdown}>
                <div className="selected-values">
                    {selectedValues.map((value) => (
                        <span key={value} className="selected-chip">
                            {teams.find((u) => u.value === value)?.label || value}
                            <button className="delete-chip" onClick={() => handleDelete(value)}>
                                &times;
                            </button>
                        </span>
                    ))}
                </div>
                <span className="dropdown-icon material-symbols-outlined">
                    {isDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </div>
            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <div className='search-input-wrapper'>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={t('search')}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <ul className="dropdown-list">
                        {filteredTeams.map((team) => (
                            <li key={team.value}
                                className={`dropdown-item ${
                                    selectedValues.includes(team.value) ? "selected" : ""
                                }`}
                                onClick={() => handleSelect(team.value)}
                            >
                                {team.label}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}